/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TubOnboardingSurveyResponseData } from '../models/tub-onboarding-survey-response-data';
@Injectable({
  providedIn: 'root',
})
class OnboardingSurveyService extends __BaseService {
  static readonly OnboardingSurveyPostCompletedSurveyResponsePath = '/onboarding-survey/configs/{urlSuffix}/responses';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list all survey configurations
   *
   * List all the survey configurations that are currently configured on the server.
   * @param params The `OnboardingSurveyService.OnboardingSurveyPostCompletedSurveyResponseParams` containing the following parameters:
   *
   * - `urlSuffix`: URL suffix of the survey to get
   *   URL suffix of the survey to set
   *   URL suffix of the survey to post a response for
   *
   * - `responseData`: The response data from the user.
   */
  OnboardingSurveyPostCompletedSurveyResponseResponse(params: OnboardingSurveyService.OnboardingSurveyPostCompletedSurveyResponseParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.responseData;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/onboarding-survey/configs/${encodeURIComponent(String(params.urlSuffix))}/responses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * list all survey configurations
   *
   * List all the survey configurations that are currently configured on the server.
   * @param params The `OnboardingSurveyService.OnboardingSurveyPostCompletedSurveyResponseParams` containing the following parameters:
   *
   * - `urlSuffix`: URL suffix of the survey to get
   *   URL suffix of the survey to set
   *   URL suffix of the survey to post a response for
   *
   * - `responseData`: The response data from the user.
   */
  OnboardingSurveyPostCompletedSurveyResponse(params: OnboardingSurveyService.OnboardingSurveyPostCompletedSurveyResponseParams): __Observable<null> {
    return this.OnboardingSurveyPostCompletedSurveyResponseResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module OnboardingSurveyService {

  /**
   * Parameters for OnboardingSurveyPostCompletedSurveyResponse
   */
  export interface OnboardingSurveyPostCompletedSurveyResponseParams {

    /**
     * URL suffix of the survey to get
     * URL suffix of the survey to set
     * URL suffix of the survey to post a response for
     */
    urlSuffix: string;

    /**
     * The response data from the user.
     */
    responseData: TubOnboardingSurveyResponseData;
  }
}

export { OnboardingSurveyService }
